"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveText = void 0;
// (C) 2020 GoodData Corporation
var ResponsiveText_1 = require("./ResponsiveText");
Object.defineProperty(exports, "ResponsiveText", { enumerable: true, get: function () { return ResponsiveText_1.ResponsiveText; } });
//# sourceMappingURL=index.js.map